module.exports = __webpack_public_path__ + "static/media/spinner.f4404720.gif";